<template>
  <section class="d-flex">
    <div class="image-section">
      <img :src="section.blob_url" />
    </div>
    <div class="d-flex align-items-center ml-1">
      <SectionControls :case-study-id="caseStudyId" :index="index" v-if="editable" />
    </div>
  </section>
</template>
<script>
import SectionMixin from '@app/mixins/case_study_section'
import SectionControls from '@components/case_study_sections/SectionControls.vue'

export default {
  name: 'ImageSection',
  mixins: [SectionMixin],
  components: { SectionControls },
  props: {
    caseStudyId: { type: Number, required: true },
    section: { type: Object, required: true },
    index: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
  },
  computed: {
    editableText() {
      // In Vue 3 you have to use null/undefined to make an attribute conditionally
      // not render, false won't work
      return this.editable ? true : null
    },
  },
}
</script>

<style lang="sass" scoped>
.delete
  cursor: pointer

.image-section
  width: 100%

.image-section img
  width: 480px
  height: auto
</style>
